import { SumDailyInRange } from '../../utils/arrayUtils';
import { AddDays, ToIsoDate } from '../../utils/dateUtils';

/**
 * Soma quantidades dentro de um range absoluto de datas (UTC).
 * `dailyByDate` é Map<isoDate, qty>; ausentes contam como 0.
 */
export function SumWindow(dailyByDate, fromIso, toIso) {
    return SumDailyInRange(dailyByDate, fromIso, toIso);
}

/** Soma janela "voltando N dias do anchor" (inclui anchor). */
export function SumLastDaysFromAnchor(dailyByDate, anchorIso, days) {
    if (!anchorIso || days <= 0) return 0;
    const anchorDate = new Date(`${anchorIso}T00:00:00Z`);
    const fromDate = AddDays(anchorDate, -(days - 1));
    return SumDailyInRange(dailyByDate, ToIsoDate(fromDate), anchorIso);
}

/** Soma janela "N dias começando offset dias antes do anchor". */
export function SumOffsetWindow(dailyByDate, anchorIso, days, offsetDays) {
    if (!anchorIso || days <= 0) return 0;
    const anchorDate = new Date(`${anchorIso}T00:00:00Z`);
    const endDate = AddDays(anchorDate, -offsetDays);
    const startDate = AddDays(endDate, -(days - 1));
    return SumDailyInRange(dailyByDate, ToIsoDate(startDate), ToIsoDate(endDate));
}
